<template>
    <el-dialog title="新建分组" :visible.sync="groupingAddDialog" width="520px" :before-close="handleDialogClose" :close-on-click-modal="false" class="custom-form-dialog">
        <el-form ref="formData" :rules="formRules" :model="formData" label-position="top">
            <el-form-item label="分组名称" prop="name">
                <el-input size="small" v-model="formData.name" maxlength="20" placeholder="请输入分组名称"></el-input>
            </el-form-item>

        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDialogClose">取消</el-button>
            <el-button type="primary" :disabled="BtnDisabled" @click.stop="handleDialogConfirm" >确定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { approvalSetCateAdd } from "@/api/index.js"
export default {
    props: {
        groupingAddDialog: {
            type: Boolean,
            default: false
        },

    },
    data() {
        return {
            BtnDisabled:false,
            formData: {
                name: "",
            },
            formRules: {
                name: [
                    {required: true, message: "请输入分组名称"}
                ]
            },
            userList: []
        }
    },
    methods: {
        handleDialogClose() {
            this.$emit("update:groupingAddDialog", false)
        },
        handleDialogConfirm() {
            this.$refs.formData.validate(valid => {
                if (valid) {
                    this.BtnDisabled = true
                    approvalSetCateAdd({name: this.formData.name}).then(res=> {
                        if(res.code === 200) {
                           this.$message({
                               type: 'success',
                               message: res.message,
                               duration: 1500,
                               onClose: () => {
                                  this.handleDialogClose()
                                  this.$emit('success')
                                  this.BtnDisabled = false
                               }
                           })
                        }else{
                             this.BtnDisabled = false
                        }
                    })

                }
            })
        },

    }
}
</script>
